import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11.954,2.454c0,0 -2.287,1.779 -3.431,2.668c-1.59,1.236 -6.11,4.75 -6.11,4.75l9.541,7.583l10.008,-7.501l-10.008,-7.5Z",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.55px"
			}
		}), /* @__PURE__ */ _jsx("path", {
			d: "M1.88,14.281l10.167,7.499l10.448,-7.774",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.55px"
			}
		})]
	})
});
export default SvgLayers;
